import CountrySelectBox, { CountryItem } from '@/components/CountrySelectBox';
import { Controller, useFormContext } from 'react-hook-form';

interface StoreAddressFormProps {
  name: string;
}

const StoreAddressForm = ({ name }: StoreAddressFormProps) => {
  const { register, control } = useFormContext();

  return (
    <div className="grid grid-cols-2 gap-4 lg:gap-8">
      <div className="col-span-2">
        <label htmlFor={`${name}.building`} className="block font-medium text-gray-700">
          Building:
        </label>
        <input
          type="text"
          id={`${name}.building`}
          {...register(`${name}.building`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-2">
        <label htmlFor={`${name}.street1`} className="block font-medium text-gray-700">
          Street 1:
        </label>
        <input
          type="text"
          id={`${name}.street1`}
          {...register(`${name}.street1`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-2">
        <label htmlFor={`${name}.street2`} className="block font-medium text-gray-700">
          Street 2:
        </label>
        <input
          type="text"
          id={`${name}.street2`}
          {...register(`${name}.street2`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-1">
        <label htmlFor={`${name}.postalCode`} className="block font-medium text-gray-700">
          Postal Code:
        </label>
        <input
          type="text"
          id={`${name}.postalCode`}
          {...register(`${name}.postalCode`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-1">
        <label htmlFor={`${name}.region`} className="block font-medium text-gray-700">
          Region:
        </label>
        <input
          type="text"
          id={`${name}.region`}
          {...register(`${name}.region`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-1">
        <label htmlFor={`${name}.city`} className="block font-medium text-gray-700">
          City:
        </label>
        <input
          type="text"
          id={`${name}.city`}
          {...register(`${name}.city`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full"
        />
      </div>

      <div className="col-span-1">
        <Controller
          name={`${name}.countryCode`}
          control={control}
          render={({ field }) => (
            <CountrySelectBox
              value={field.value}
              onSelect={(country: CountryItem | null) => field.onChange(country?.id || '')}
            />
          )}
        />
      </div>

      <div className="col-span-2">
        <label
          htmlFor={`${name}.additionalDescription`}
          className="block font-medium text-gray-700"
        >
          Additional Description:
        </label>
        <textarea
          id={`${name}.additionalDescription`}
          {...register(`${name}.additionalDescription`)}
          className="mt-1 p-2 border border-gray-300 rounded-md w-full h-24 resize-none"
        />
      </div>
    </div>
  );
};

export default StoreAddressForm;
